import { useQuery } from "@tanstack/react-query";

import useUserStore from "@store/useUserStore";
import { TIMEZONE_QUERY_KEY } from "@config/query";
import { Timezone } from "@app-types/date.type";
import { findTimezoneByPlace, generateTimezonesWithOffsets } from "@utils/date.util";

export function useTimezones() {
  const { activeUser } = useUserStore();

  const { data, error, isLoading } = useQuery({
    queryKey: [TIMEZONE_QUERY_KEY],
    queryFn: async () => {
      return Promise.resolve(generateTimezonesWithOffsets());
    },
    staleTime: Infinity,
  });

  let userTimezoneOffset: Timezone = "+00:00";
  if (!isLoading && !error && data && !!activeUser) {
    const userTimezone = findTimezoneByPlace(activeUser!.timezone as string, data);
    userTimezoneOffset = userTimezone?.offsetString ?? "+00:00";
  }

  return { data, error, isLoading, userTimezoneOffset };
}
